import { Component } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { SizeableDirective } from '../../directives/sizeable.directive';

@Component({
  selector: 'app-spinner',
  standalone: true,
  imports: [MatProgressSpinnerModule],
  templateUrl: './spinner.component.html',
  styleUrl: './spinner.component.scss',
  providers:  [{ provide: SizeableDirective, useExisting: SpinnerComponent }]
})
export class SpinnerComponent extends SizeableDirective {
}
